import React, { Fragment } from 'react';
import DefaultResourceMappings from './DefaultResourceMappings';
import KeyResourceMappings from './KeyResourceMappings';
import DefaultKeyMappings from './DefaultKeyMappings';

const DMTDefaultMappings = () => (
    <Fragment>
        <DefaultResourceMappings />
        <DefaultKeyMappings />
        <KeyResourceMappings />
    </Fragment>
);

export default DMTDefaultMappings;
